export const SMS_REQUEST_CHUNK_SIZE = 4;

export default { SMS_REQUEST_CHUNK_SIZE };
